import { isString } from "lodash";

import valuesAreEqual from "../../utils/valuesAreEqual";
import removeMillisecondsFromDateString from "./removeMillisecondsFromDateString";

const valueSoundsTrue = value => value === true || value === "Yes" || value === "true";
const valueSoundsFalse = value => !value || value === "No" || value === "false";

/**
 * Because Scrivener dates may or may not end with .0000, I am stripping .0000 off the end
 * of any strings before comparison
 * @param {any} a
 * @param {any} b
 */
const strippedValuesAreEqual = (a, b) => {
  if (isString(a) && isString(b)) {
    return removeMillisecondsFromDateString(a) === removeMillisecondsFromDateString(b);
  }
  return valuesAreEqual(a, b);
};

const syncValuesAreEqual = (a, b) =>
  strippedValuesAreEqual(a, b) ||
  (valueSoundsTrue(a) && valueSoundsTrue(b)) ||
  (valueSoundsFalse(a) && valueSoundsFalse(b));

export default {
  valueSoundsTrue,
  valueSoundsFalse,
  valuesAreEqual: syncValuesAreEqual
};
